import { useSelector } from 'react-redux'
import { useAppDispatch } from '@/state'
import { DialogModel } from '@/state/ui/global/models'

import {
  uiGlobalSelector,
  setDialogAction,
} from '@/state/ui/global/slices/index.slices'

function useDialog() {
  const dispatch = useAppDispatch()

  const { dialog } = useSelector(uiGlobalSelector)

  const handleDialogAction = (payload: boolean | DialogModel) => {
    dispatch(
      setDialogAction(
        typeof payload === 'boolean' ? { open: payload } : payload,
      ),
    )
  }

  const handleCloseDialog = () => {
    dispatch(
      setDialogAction({
        open: false,
      }),
    )
  }

  return { dialog, handleDialogAction, handleCloseDialog }
}

export default useDialog
